import {NetatmoDataGranularity} from '../../api/types';
import * as Time from '../Time';
import ChartsDataContainer from './ChartsDataContainer';
import * as ChartUtils from './ChartUtils';
import * as Utils from './Utils';

export type ComparisonType =
  | 'previousDay'
  | 'sameDayLastYear'
  | 'previous24Hours'
  | 'previousWeek'
  | 'previous7Days'
  | 'previousMonth'
  | 'previous30Days'
  | 'sameMonthLastYear'
  | 'previousYear';

export type ComparisonConfig = {
  type:
    | 'previousDay'
    | 'sameDayLastYear'
    | 'previous24Hours'
    | 'previousWeek'
    | 'previous7Days'
    | 'previousMonth'
    | 'previous30Days'
    | 'sameMonthLastYear'
    | 'previousYear';
};

export type IndoorNetatmoMetric =
  'Temperature' | 'Humidity' | 'Noise' | 'CO2' | 'Pressure';

export type OutdoorNetatmoMetric = 'Temperature' | 'Humidity' | 'Rain' | 'Wind';

export type NetatmoMetric = IndoorNetatmoMetric | OutdoorNetatmoMetric;

export type ChartConfig = {
  scale: Time.Scale;
  granularity: NetatmoDataGranularity;
  comparison: ComparisonConfig;
};

export {ChartUtils, ChartsDataContainer, Utils};
